import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FiMail } from "react-icons/fi";
import Logo from "../components/Logo";
import api from "../services/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setLoading(true);
    await api.forgotPassword(email);
    setLoading(false);
    // Always show the same message, regardless of outcome.
    setSent(true);
  }

  return (
    <section className="section-container flex justify-center py-20">
      <div className="card w-full max-w-md p-8">
        <div className="flex justify-center">
          <Logo withTagline={false} />
        </div>

        {sent ? (
          <div className="mt-8 text-center">
            <FiMail className="mx-auto text-primary" size={40} />
            <h1 className="mt-4 text-xl font-bold">Check your email</h1>
            <p className="mt-2 text-sm text-slate-600">
              If an account exists for <strong>{email}</strong>, you'll
              receive an email with instructions to reset your password.
            </p>
            <Link to="/login" className="btn-primary mt-6 w-full">
              Back to Log in
            </Link>
          </div>
        ) : (
          <>
            <h1 className="mt-6 text-center text-2xl font-bold">
              Forgot your password?
            </h1>
            <p className="mt-1 text-center text-sm text-slate-600">
              Enter your email and we'll send you a reset link.
            </p>
            <form onSubmit={handleSubmit} className="mt-8">
              <label className="mb-1.5 block text-sm font-medium text-navy" htmlFor="fp-email">
                Email Address
              </label>
              <input
                id="fp-email"
                type="email"
                required
                className="input-field"
                placeholder="you@company.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <button
                type="submit"
                disabled={loading}
                className="btn-primary mt-6 w-full disabled:opacity-60"
              >
                {loading ? "Sending..." : "Send Reset Link"}
              </button>
            </form>
            <p className="mt-6 text-center text-sm text-slate-600">
              Remembered it?{" "}
              <Link to="/login" className="font-medium text-primary hover:underline">
                Back to Log in
              </Link>
            </p>
          </>
        )}
      </div>
    </section>
  );
}
